import { render, staticRenderFns } from "./FilterSettingsManager.vue?vue&type=template&id=13b361fa"
import script from "./FilterSettingsManager.vue?vue&type=script&lang=js"
export * from "./FilterSettingsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports